import React from 'react';
import { ThreeCircles } from 'react-loader-spinner';
//Used for displaying a blocking spinner while interacting with the API
const LoadingData = () => {
    return (
        <div style={{
            position: 'fixed', // Keep overlay fixed over content
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)', // Semi-transparent background
            display: 'flex',
            justifyContent: 'center', // Center the spinner horizontally
            alignItems: 'center', // Center the spinner vertically
            zIndex: 9999, // Ensure it's above all other content
        }}>
            <ThreeCircles
                visible={true}
                height="100"
                width="100"
                color="#59d0ff"
                ariaLabel="three-circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
};
export default LoadingData;
